module.exports = __webpack_public_path__ + "c2b97a84f32ab43f45ff958f84c0b4c7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo-moka.png
// module id = 3162
// module chunks = 0